var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 21.5859H6.33203C3.91403 21.5859 2.58203 20.2539 2.58203 17.8359V8.83594C2.58203 6.41794 3.91403 5.08594 6.33203 5.08594H18.332C20.75 5.08594 22.082 6.41794 22.082 8.83594V17.8359C22.082 20.2539 20.75 21.5859 18.332 21.5859ZM6.33203 6.58594C4.75503 6.58594 4.08203 7.25894 4.08203 8.83594V17.8359C4.08203 19.4129 4.75503 20.0859 6.33203 20.0859H18.332C19.909 20.0859 20.582 19.4129 20.582 17.8359V8.83594C20.582 7.25894 19.909 6.58594 18.332 6.58594H6.33203ZM13.3611 14.0149L18.2729 10.4429C18.6079 10.1999 18.682 9.72994 18.438 9.39494C18.195 9.06094 17.7271 8.98493 17.3901 9.22993L12.478 12.8019C12.39 12.8659 12.2731 12.8659 12.1851 12.8019L7.27295 9.22993C6.93495 8.98493 6.4681 9.06194 6.2251 9.39494C5.9811 9.72994 6.05514 10.1989 6.39014 10.4429L11.302 14.0159C11.61 14.2399 11.9711 14.3509 12.3311 14.3509C12.6911 14.3509 13.0541 14.2389 13.3611 14.0149Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.89dc8b924b089aaed4724d3ed04ef7fa.svg";
export { ForwardRef as ReactComponent };